import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(timezone);
dayjs.extend(utc);

// The native DayJS add function does not work across timezone changes
// This function works around that by adding the days to the date in the
// specified timezone without touching the MS count
export default (dayJsDate: Dayjs, quantity: number) => {
  const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone || dayjs.tz.guess();
  const clone = dayjs.tz(dayJsDate, timezoneName);
  return clone.date(clone.date() + quantity).tz(timezoneName, true);
};
